import { React, useState,useEffect } from "react";
import "./landing.css";
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import image from  "./img/switch.png";
import logoutimg from "./img/logout.png";
import imagebk from  "./img/back.png";
import {CREATE_SOFTWARE_ACCESS,GET_SAVEDSOFTWAREREQ} from '../AppConstant'
function Landing() {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [contact, setContact] = useState("");
    const [pan, setPan] = useState("");
    const [bod, setBod] = useState("");
    const [doj, setDoj] = useState("");
    const [requestorname,setRequestorname]= useState("");
    const [requestdept,setRequestdept]= useState("");
    const [location,setLocation]= useState("");
    const [softwaretitles,setSoftwaretitles]= useState("");
    const [version,setVersion]= useState("");
    const [vendorname,setVendorname]= useState("");
    const [softwarerefs,setsoftwarerefs]= useState("");

    const [purpose,setPurpose]= useState("");
    const [asset_id,setAsset_id]= useState("");
    const [selectedrpmanager,setSelectedrpmanager] = useState("");
    const [ifchecked,setIfchecked] = useState(false);
    const [selectedtext,setSelectedtext] = useState("");
    const [start,setStart] = useState(""); 
    const [end,setEnd] = useState(""); 
    const [mindateset,setMindateset] = useState("")
    const [oemname,setOemname]= useState("")
    const [licenseperiod,setLicenseperiod]= useState("")
    const [ponumber,setponumber]= useState("")
    const [noflicense,setNoflicense]= useState("")
    const [amc,setAmc]= useState("")
    const [swsupport,setSwsupport]= useState("")
    const [licensekey,setLicensekey]= useState("")
   const [isfirsttab,setIsfirsttab]= useState(true);
    const [issecondtab,setIssecondtab]= useState(false);
    const [softwarelist,setSoftwarelist]= useState("")
    const calltosetmindate=()=>{
        setSelectedrpmanager(localStorage.getItem('functionheademail'))
        let month;
        let day;
        if((new Date().getMonth()+1)<9){
            month="0"+(new Date().getMonth()+1)
        }else{
            month= (new Date().getMonth()+1)
        }
        if( new Date().getDate()<9){
            day= "0"+new Date().getDate()
        }else{
            day= new Date().getDate()
        }
        let date = new Date().getFullYear()+'-'+month+'-'+day
       setMindateset(date)
    }
    useEffect(()=>{calltosetmindate()},[])
    const handleSubmit = (e) => {
        var textareas = document.getElementById("myTextarea").value;
        e.preventDefault();
        if(!location||!softwaretitles||!version||!vendorname||!softwarerefs||!textareas||!selectedrpmanager||!oemname||!licenseperiod||!ponumber||!noflicense||!licensekey||!amc||!swsupport){
            alert("Please fill all the fields")
        }else{                              
             getUserData();       
            
        }
        
        // Add your form submission logic here
        
    };

    const redirectToLogin = ()=>{
        window.location.href = "/login"
    }
    
     const handleReset = () => {
        // Reset all state variables here
        setRequestdept("");
        setRequestorname("");
        setPurpose("");
        setAsset_id("");
        setSelectedrpmanager("")
        setIfchecked(false)
        const Checkboxes = document.getElementById('checkboxs');
        if(Checkboxes.checked===true){
            Checkboxes.checked=false
        }
        
    };
    const getUserData = ()=>{
       
      
        var textareas = document.getElementById("myTextarea").value;
        // let empid= requestorname
        // let rqdept= requestdept
        let empid=  localStorage.getItem('empid');
        let rqdept= localStorage.getItem('dept');
        let worklocation= location
        let assetid= asset_id
        let softwaretitle= softwaretitles
        let functionalhd= localStorage.getItem('reporting_manageremail')
        let vendor= vendorname
        let softwareref= softwarerefs
        let reasons= textareas        
        let empemailid = localStorage.getItem('emailid');
        let empname = localStorage.getItem('empname');
        let fhname =localStorage.getItem('reporting_managername');; 
        let versions=version  
               
                
        axios.post(CREATE_SOFTWARE_ACCESS, {empid,rqdept,worklocation,assetid,softwaretitle,functionalhd,vendor,softwareref,reasons,empemailid,fhname,empname,versions,oemname,licenseperiod,ponumber,noflicense,licensekey,amc,swsupport})
        .then(function (response) {
          //console.log("SuccessFully updated");
          alert(response.data);
          handleReset();
          

        })
          .catch(function (error) {
            console.log(error);
          });
       
    }
    const redirectTodashboard = ()=>{
        window.location.href = "/landingPage"
    }

    const checkedval=(e)=>{
        if(e.currentTarget.checked===true){
            setIfchecked(true)
        }else{
            setIfchecked(false)
        }
       
    }
    const callselectedfn=(e)=>{
        setSelectedrpmanager(e.target.value)
        setSelectedtext(e.target.options[e.target.selectedIndex].innerText)
    }
    const callinputsetfn=(e)=>{
        if(e.target.value.length>6){
            alert("Employee ID cannot exceed 6 digit")           
        }else{
            setRequestorname(e.target.value)
        }   
        
    }
    const isAlpha = checkvalue => /^[a-zA-Z]*$/.test(checkvalue)
    const assetentryfn=(e)=>{
        let checkvalue =e.target.value
        if(e.target.value.length===12){
            let strRegex = new RegExp(/^[A-Za-z]+$/i);
            let result1 = strRegex.test(checkvalue);
            let strRegex2 = new RegExp(/^[0-9]+$/i);
            let result2 = strRegex2.test(checkvalue);
            if(result1 || result2===true){
                setAsset_id("")
                alert("Should contain alphanumeric")
            }else{
                setAsset_id(e.target.value)
            }
           
        }else{
            setAsset_id(e.target.value)
        }
        
    }
     const enabletab=(e)=>{
        if(e===2){
            setIsfirsttab(false)
            setIssecondtab(true)
            callsaveddata()
        }else{
           
            setIsfirsttab(true)
            setIssecondtab(false)
        }
       }
       const callsaveddata=()=>{
               axios({
                   method: "get",
                   url: GET_SAVEDSOFTWAREREQ,
                   withCredentials: false,
                   headers: {
                     "Content-Type": "application/x-www-form-urlencoded",
                     "Access-Control-Allow-Origin": "*",
                   },
                   params:{"emp_id" : localStorage.getItem('empid')}
                 })
                   .then((response) => {
                       // setsavedvendorraw(response.data.data)
                       setSoftwarelist(response.data.data);
                   })
                   .catch((error) => {
                     console.error(error);
                   });
           }
    return (
        <form action="#" method="get">
                 <div className="row">
                    {/* <div className="col-md-6">
                    <label for="firstname">
                    Emp ID
                    </label>
                    <input
                        type="number"
                        name="firstname"
                        id="firstname"
                        value={requestorname}
                        onChange={(e) =>
                            callinputsetfn(e)
                        }
                        maxlength="6"
                        placeholder="Emp ID"
                        required
                    />
                    </div> */}
                    {/* <div className="col-md-6">
                    <label for="lastname">Requestor department</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={requestdept}
                        onChange={(e) =>
                            setRequestdept(e.target.value)
                        }
                        placeholder="Department"
                        required
                        maxlength="30"
                    />
                    </div> */}
                    <div className="row tabdesign_vm">
            <div className={isfirsttab?"col-md-2 tabfirst-selected":"col-md-2 notselected"} onClick={()=>enabletab(1)}>Creation</div>  
            <div className={issecondtab?"col-md-2 tabfirst-selected":"col-md-2 notselected"} onClick={()=>enabletab(2)}>View </div> 
         
       
           
            {/* <div className="col-md-2 tabfour">View Request</div> */}
             </div> 
                    </div>
                     {isfirsttab?<>
                <div className="row">
                    {/* <div className="col-md-6">
                    <label for="firstname">
                    Emp ID
                    </label>
                    <input
                        type="number"
                        name="firstname"
                        id="firstname"
                        value={requestorname}
                        onChange={(e) =>
                            callinputsetfn(e)
                        }
                        maxlength="6"
                        placeholder="Emp ID"
                        required
                    />
                    </div> */}
                    {/* <div className="col-md-6">
                    <label for="lastname">Requestor department</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={requestdept}
                        onChange={(e) =>
                            setRequestdept(e.target.value)
                        }
                        placeholder="Department"
                        required
                        maxlength="30"
                    />
                    </div> */}
                    </div>
                    <div className="row">
                    <div className="col-md-4"> <label for="lastname">Work Location</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={location}
                        onChange={(e) =>
                            setLocation(e.target.value)
                        }
                        placeholder="Location"
                        required
                        
                    />
                    </div>
                    <div className="col-md-4">
                    <label for="lastname">Asset ID</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={asset_id}
                        onChange={(e) =>
                            assetentryfn(e)                          
                        }
                        
                        placeholder="Asset ID"
                        required
                        
                    />
                    </div>
                    <div className="col-md-4">
                    <label for="lastname">Software Title</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={softwaretitles}
                        onChange={(e) =>
                            setSoftwaretitles(e.target.value)                        
                        }
                        
                        placeholder="Software Title"
                        required
                        
                    />
                    </div>
                    <div className="col-md-4">
                    <label>Version</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={version}
                        onChange={(e) =>
                            setVersion(e.target.value)                            
                        }
                        
                        placeholder="version"
                        required
                        
                    />
                        </div>
                    <div className="col-md-4">
                    <label>No.of License</label>
                    <input
                        type="number"
                        name="noflicense"
                        id="noflicense"
                        value={noflicense}
                        onChange={(e) =>
                            setNoflicense(e.target.value)                            
                        }
                        
                        placeholder="No.of License"
                        required
                        
                    />
                        </div>
                        <div className="col-md-4">
                    <label>License period</label>
                    <input
                        type="text"
                        name="noflicense"
                        id="noflicense"
                        value={licenseperiod}
                        onChange={(e) =>
                            setLicenseperiod(e.target.value)                            
                        }
                        
                        placeholder="License period(i.e 1 year)"
                        required
                        
                    />
                        </div>
                        
                        <div className="col-md-4">
                    <label>License Key</label>
                    <input
                        type="text"
                        name="licensekey"
                        id="noflicense"
                        value={licensekey}
                        onChange={(e) =>
                            setLicensekey(e.target.value)                            
                        }
                        
                        placeholder="License Key"
                        required
                        
                    />
                        </div>
                    <div className="col-md-4">
                    <label for="lastname">OEM Name</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={oemname}
                        onChange={(e) =>
                            setOemname(e.target.value)                        
                        }
                        
                        placeholder="OEM Name"
                        required
                        
                    />
                    </div>
                    
                    <div className="col-md-4">
                    <label for="lastname">PO Number</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={ponumber}
                        onChange={(e) =>
                            setponumber(e.target.value)                        
                        }
                        
                        placeholder="po Number"
                        required
                        
                    />
                    </div>
                    <div className="col-md-4">
                    <label for="lastname">AMC</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={amc}
                        onChange={(e) =>
                            setAmc(e.target.value)                        
                        }
                        
                        placeholder="AMC"
                        required
                        
                    />
                    </div>
                    <div className="col-md-4">
                    <label for="lastname">S/W support name/details</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={swsupport}
                        onChange={(e) =>
                            setSwsupport(e.target.value)                        
                        }
                        
                        placeholder="S/W support"
                        required
                        
                    />
                    </div>
                    
                        <div className="col-md-4">
                    <label for="lastname">Vendor</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={vendorname}
                        onChange={(e) =>
                            setVendorname(e.target.value)                           
                        }
                        
                        placeholder="Vendor"
                        required
                        
                    />
                    </div>
                    <div className="col-md-4">
                    <label>Website Reference</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={softwarerefs}
                        onChange={(e) =>
                            setsoftwarerefs(e.target.value)                          
                        }
                        
                        placeholder="version"
                        required
                        
                    />
                        </div>
                        <div>
                        <label>Detailed Justification(s) for installation</label>
                        <textarea
                  id="myTextarea"
                  name="postContent"
                  
                  rows={4}
                  cols={40}
                />
                        </div>
                    </div>
                    
                    <div className="col-md-12">
                    <label>  Reporting Manager</label>
                    <select
                        name="select"
                        id="select"
                        value={selectedrpmanager}
                        onChange={(e) =>callselectedfn(e)}
                    >
                        <option
                            value=""
                            disabled
                            selected={selectedrpmanager === ""}
                        >
                             Reporting Manager
                        </option>
                             <option  value={localStorage.getItem('reporting_manageremail')}>{localStorage.getItem('reporting_managername')}</option>

                            
							
							
							 
							
                            {/* <option value="2">CSS</option>
                            <option value="3">
                                JavaScript
                            </option> */}                       
                        </select>
                        </div>
                        <div className="text-design-note">Note: Please provide a detailed justification for the access request.</div>
                        <div className="row">
                    <div className="col-md-6">
                    <Button
                        variant="primary"
                        className="btns"
                        type="reset"
                        value="reset"
                        onClick={() => handleReset()}
                    >
                        Clear
                    </Button>
                    </div>
                    <div className="col-md-6">
                    <Button
                    variant="primary"
                      className="btns"
                        type="submit"
                        value="Submit"
                        onClick={(e) => handleSubmit(e)}
                    >
                        Submit
                    </Button>
                    </div>
                    </div>
                    </>:<div className="table-boxs">
                <div className="row">
                        {/* <div className="col-md-1"><label htmlFor="switchcode">
                        Search
                        </label></div> */}
                        {/* <div className="col-md-3"><input
                            type="text"
                            name="switchcode"
                            id="switchcode"
                            value={searchdata}
                            onChange={(e) =>
                                searchfunction(e.target.value)
                            }
                            placeholder="Search"
                            required
                        /></div> */}
                        {/* <div className="col-md-1">
                            <Button variant="info" 
                            onClick={() => generatereport()}
                        >
                            <img style={{width: "80%",cursor: "pointer",filter:"invert(1)"}} className="" src={downloadimgbk} title="download"/> 
                        </Button> 
                        </div> */}
                        </div>
                <table className="table-full mt-3">
              <thead className="header-asset">
                <tr>
                  <th>Sl.No</th>
                  <th>Software Title</th>
                  <th>Location</th>                              
                  <th>Vendor</th>
                  {/* <th>DOJ</th> */}
                  <th>versions</th>
                  {/* <th>Vendor Name</th> */}
                  {/* <th>Sub Department</th> */}
                  <th>Functional Head</th>
                  {/* <th>Manager Employee ID</th> */}
                  {/* <th>Contractor Name</th>
                  <th>Vendor Code</th> */}
                  {/* <th>Verified</th>
                  <th>Status</th>
                  <th>Remarks</th> */}
                   <th>Status</th>
                   <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
              {softwarelist.length?softwarelist.map((val, i) => {
                      return (
                        <tr>
                           
                          <td>{i+1}</td>
                          <td>{val.softwaretitle}</td>
                          <td>{val.worklocation}</td>
                          <td>{val.vendor}</td>
                          {/* <td>{val.doj}</td>  */}
                          <td>{val.versions}</td>                         
                          {/* <td>{val.sub_department}</td>  */}
                          <td>{val.functionalhd}</td> 
                          {/* <td>{val.manager_id}</td>  */}
                          {/* <td>{val.contractor_name}</td> 
                          <td>{val.vendor_code}</td>  
                          <td>{val.verified}</td>
                          <td>{val.status} </td> 
                          <td>{val.remarks}</td>*/}
                            {/* <td style={{width:"15%"}}><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>mailsent(val)} className="" src={sentmail} title="Sent Mail"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>edituser(val)} className="" src={edit} title="Edit"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>removeuser(val)} className="" src={remove} title="Remove"/></td> */}

                          {/* <td style={{cursor:"pointer"}}onClick={(e)=>calllvconnectorselected(e,val)}>edit</td> */}
                           <td>{val.remarks==''?"Submitted":val.remarks}</td>
                           <td>{val.remarks=='Functional Head Approved'?"Pending With Infra Team":val.remarks=='Infra Team Approved'?'Pending With IT Head':val.remarks=='Access Provided'?'Completed':"Pending with Functional Head"}</td>
                          
                        </tr>
                      );
                    })
                  : ""}
              
              </tbody>
            </table></div>}

                </form>
        // <div className="bg_set_usb">   
        //  <div className="switch" >
        //             <img className="switch-back" onClick={redirectTodashboard} src={imagebk}/>
        //             <img className="switch-img" src={image}/>
        //             <img className="logout-img" title="Logout" onClick={redirectToLogin} src={logoutimg}/>
        //         </div><br/><br/>         
        //      <div>
        //     </div>
        //     <div>
        // <div className="Apps ">
        //     <p className="Headings">Software Access Requisition</p>
        //     <fieldset>
                
        //     </fieldset>
        // </div> 
        //     </div>
        
        // </div>
    );
}


export default Landing;
